module.exports = __webpack_public_path__ + "media/background-home-video.7a1da52c.mp4";